import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { buttonResetStyles } from "../../../utils";
import { colors } from "../../../utils/colors";
import { HeroTitle } from "../../atoms/HeroTitle";

export const Outer = styled.div`
`;

export const Spacer = styled.div`
    margin-bottom: 50px;
`;

export const Inner = styled.div`
    padding: 50px 0;

    ${breakpoints.large} {
        padding: 60px 0;
    }
`;

export const Title = styled(HeroTitle)`
    color: ${colors.white};
    text-align: center;
    font-weight: 800;

    &.dark{
        color: ${colors.dark}
    }
`;

export const Fields = styled.div`
    margin: 30px auto;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    ${breakpoints.medium} {
        max-width: 250px;
        margin: 0 auto;
    }
`;

export const LinkButton = styled.button`
    ${buttonResetStyles}
    width: auto;
    color: white;
    text-decoration: underline;
    &:hover {
        text-decoration: none;
    }
`;
